import React, { useEffect, useState } from "react";
import Base from '../../../utils/base'

export default function RoomGallery(props) {
  var base = new Base()

  return (
    <div className="gallery-top">
      <div className="gallery-top__carousel solinom-owl__carousel owl-carousel owl-theme" data-owl-options='{
        "items": 1,
        "margin": 0,
        "loop": true,
        "smartSpeed": 700,
        "nav": false, 
        "dots": false,
        "autoplay": true,
        "responsive": {
            "0": {
                "items": 1
            },
            "576": {
                "items": 2,
                "margin": 20
            },
            "992": {
                "items": 3,
                "margin": 20
            },
            "992": {
                "items": 4,
                "margin": 20
            }
        }
      }'>
        {
          props.roomInfo.arrImage != null &&
          props.roomInfo.arrImage.map((image, index) => (
            <div className="item">
              <div className="gallery-top__card">
                <img src={image.image} alt="solinom image"/>
              </div>
            </div>
          ))
        }
      </div>
    </div>
  );
};
